import { render } from "./WorldNpc1.vue?vue&type=template&id=6833d659&scoped=true"
import script from "./WorldNpc1.vue?vue&type=script&lang=js"
export * from "./WorldNpc1.vue?vue&type=script&lang=js"

import "./WorldNpc1.vue?vue&type=style&index=0&id=6833d659&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6833d659"]])

export default __exports__